export const scheduleAlertsQueryKeys = {
  all: ["schedule_alerts"] as const,
  forSiteAndDates: (siteId: string, start: Date, end: Date) =>
    [
      ...scheduleAlertsQueryKeys.all,
      siteId,
      start.toISOString(),
      end.toISOString(),
    ] as const,

  forEmployees: (
    siteId: string,
    start: Date,
    end: Date,
    employeesIds: number[],
  ) =>
    [
      ...scheduleAlertsQueryKeys.forSiteAndDates(siteId, start, end),
      { employeesIds },
    ] as const,
};
